import { GET } from './executer';
import apiServiceInstance from './apiService';

export type IngestStatus = 'succeeded' | 'failed' | 'skipped';

export interface StationIngestExecution {
  id: string;
  pubsub_message_id: string;
  season_year: number | null;
  circuit_id: string | null;
  start_date: string | null;
  station_reference: string | null;
  file_path: string;
  bucket: string;
  status: IngestStatus;
  rows_processed: number | null;
  rows_inserted: number | null;
  duration_ms: number;
  error_message: string | null;
  error_details: string | null;
  executed_at: string;
}

export interface IngestExecutionFilter {
  executed_after?: string;
  executed_before?: string;
}

export interface IngestExecutionFile {
  data: string;
  file_name: string;
  file_path: string;
}

export interface IngestLogEntry {
  timestamp: string;
  severity: string;
  message: string;
}

interface ExecutionsResponse {
  data: StationIngestExecution[];
  total: number;
  limit: number;
  offset: number;
}

class StationIngestService {
  async getExecutions(filter: IngestExecutionFilter, limit = 100, offset = 0) {
    const params = new URLSearchParams();

    if (filter.executed_after) params.append('executed_after', filter.executed_after);
    if (filter.executed_before) params.append('executed_before', filter.executed_before);

    params.append('limit', String(limit));
    params.append('offset', String(offset));

    const url = `/api/station-ingest/executions?${params.toString()}`;

    return await apiServiceInstance.client.execute<ExecutionsResponse>(GET, url);
  }

  async getExecutionLogs(executionId: string) {
    const url = `/api/station-ingest/executions/${executionId}/logs`;

    return await apiServiceInstance.client.execute<IngestLogEntry[]>(GET, url);
  }

  async getExecutionFile(executionId: string) {
    const url = `/api/station-ingest/executions/${executionId}/file`;

    return await apiServiceInstance.client.execute<IngestExecutionFile>(GET, url);
  }
}

const stationIngestService = new StationIngestService();
export default stationIngestService;
